import React, { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    // Clean up all legacy auto-saved theme keys
    localStorage.removeItem("theme");
    localStorage.removeItem("app_theme_mode");

    // If user is not logged in, always default to dark mode on website open
    const loggedIn = localStorage.getItem("data");
    if (!loggedIn) {
      localStorage.removeItem("user_toggled_theme");
      return "dark";
    }

    const userChoice = localStorage.getItem("user_toggled_theme");
    if (userChoice === "light" || userChoice === "dark") {
      return userChoice;
    }
    return "dark";
  });

  useEffect(() => {
    document.body.classList.remove("light-theme", "dark-theme");
    document.body.classList.add(`${theme}-theme`);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => {
      const nextTheme = prev === "light" ? "dark" : "light";
      localStorage.setItem("user_toggled_theme", nextTheme);
      return nextTheme;
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    return { theme: "dark", toggleTheme: () => {} };
  }
  return context;
}
